import type { CoreConfig } from "@/core"
import type { EmailConfig } from "@/email"
import type { PermissionsConfig } from "@/permissions/types"

export type WorkspaceConfig = {
  workspace: {
    /** Preset loaded by `bun run db:seed` when the workspace has no config row. */
    defaultPreset: string
  }
}

export type Config = CoreConfig & EmailConfig & PermissionsConfig & WorkspaceConfig

const config: Config = {
  core: {
    supportEmail: "support@yourdomain.com",
    websiteUrl: "https://www.yourdomain.com",
    projectName: "AutoCRM",
    darkMode: true,
    appTitle: "AutoCRM - Pipeline at a glance",
  },
  email: {
    from: "AutoCRM <onboarding@resend.dev>",
  },
  workspace: {
    defaultPreset: "prn",
  },
  // Roles live in the database (`user_roles`); what a role may do is defined
  // here. Adding a capability is a config change, not a migration.
  permissions: {
    roleToPermissions: {
      rep: {
        viewOwnAccounts: true,
        createAccount: true,
        editAccount: true,
        logInteraction: true,
        changeStage: true,
        usePlanner: true,
        exportData: true,
      },
      admin: {
        viewOwnAccounts: true,
        viewAllAccounts: true,
        createAccount: true,
        editAccount: true,
        deleteAccount: true,
        assignOwner: true,
        logInteraction: true,
        changeStage: true,
        usePlanner: true,
        viewConversions: true,
        manageConversions: true,
        manageConfig: true,
        importData: true,
        exportData: true,
        viewAnalytics: true,
        manageUsers: true,
      },
    },
  },
}

export default config
